var exports = {
  "k": "container__0WYrtQ",
};

module.exports = exports;
